import type { ColumnConfig } from '../../../hooks/useTableColumns';

export const caseDefaultColumns: ColumnConfig[] = [
  {
    key: 'index',
    title: '序号',
    width: 60,
    minWidth: 60,
    maxWidth: 80,
    visible: true,
    fixed: 'left',
    order: 0,
    resizable: false,
    draggable: false,
  },
  {
    key: 'case_name',
    title: '案件名称',
    dataIndex: 'case_name',
    width: 200,
    minWidth: 150,
    maxWidth: 350,
    visible: true,
    fixed: false,
    order: 1,
    resizable: true,
    draggable: true,
  },
  {
    key: 'case_type',
    title: '案件类型',
    dataIndex: 'case_type',
    width: 100,
    minWidth: 80,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 2,
    resizable: true,
    draggable: true,
  },
  {
    key: 'case_reason',
    title: '案由',
    dataIndex: ['details', 'case_reason'],
    width: 140,
    minWidth: 100,
    maxWidth: 250,
    visible: true,
    fixed: false,
    order: 3,
    resizable: true,
    draggable: true,
  },
  {
    key: 'case_level',
    title: '审级',
    dataIndex: ['details', 'case_level'],
    width: 120,
    minWidth: 80,
    maxWidth: 180,
    visible: true,
    fixed: false,
    order: 4,
    resizable: true,
    draggable: true,
  },
  {
    key: 'case_status',
    title: '状态',
    dataIndex: 'case_status',
    width: 90,
    minWidth: 80,
    maxWidth: 120,
    visible: true,
    fixed: false,
    order: 5,
    resizable: true,
    draggable: true,
  },
  {
    key: 'responsible_lawyer_name',
    title: '负责律师',
    dataIndex: 'responsible_lawyer_name',
    width: 100,
    minWidth: 80,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 6,
    resizable: true,
    draggable: true,
  },
  {
    key: 'assistant_lawyer_name',
    title: '助理律师',
    dataIndex: 'assistant_lawyer_name',
    width: 100,
    minWidth: 80,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 7,
    resizable: true,
    draggable: true,
  },
  {
    key: 'next_follow_up_time',
    title: '下次跟进时间',
    dataIndex: 'next_follow_up_time',
    width: 150,
    minWidth: 130,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 7.5,
    resizable: true,
    draggable: true,
  },
  {
    key: 'accept_date',
    title: '承接日期',
    dataIndex: 'accept_date',
    width: 110,
    minWidth: 100,
    maxWidth: 150,
    visible: true,
    fixed: false,
    order: 8,
    resizable: true,
    draggable: true,
  },
  {
    key: 'court_date',
    title: '开庭时间',
    dataIndex: 'court_date',
    width: 150,
    minWidth: 130,
    maxWidth: 200,
    visible: true,
    fixed: false,
    order: 9,
    resizable: true,
    draggable: true,
  },
  {
    key: 'action',
    title: '操作',
    width: 150,
    minWidth: 120,
    maxWidth: 200,
    visible: true,
    fixed: 'right',
    order: 10,
    resizable: false,
    draggable: false,
  },
];
